export const SET_NORMALIZED_COOKIES = '@http-request/SET_NORMALIZED_COOKIES';

export function setNormalizedCookies(normalizedCookies: {}) {
  return {
    type: SET_NORMALIZED_COOKIES,
    payload: normalizedCookies,
  };
}
